

























import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      show: false
    };
  },
  computed: {
    showMenu(): boolean {
      const show = this.show;
      return show || this.open;
    }
  },
  methods: {
    clickOutside(e) {
      if ((this.$refs.menu as HTMLElement).contains(e.target)) {
        // Clicked in box
      } else {
        // Clicked outside the box
        this.show = false;
        this.$emit("close", false);
      }
    },
    toggle() {
      if (this.show) {
        this.show = false;
        this.$emit("close", false);
      } else {
        this.show = true;
      }
    }
  },
  model: {
    prop: "open",
    event: "close"
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    activeItem: {
      type: String
    },
    threshold: {
      type: Number,
      default: 0
    },
    open: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  mounted() {
    window.addEventListener("click", this.clickOutside);
  },
  destroyed() {
    window.removeEventListener("click", this.clickOutside);
  }
});
